export const KNOWLEDGE_ROUTES = {
  CONTENT: "/content",
  CONTENT_HUB: "/content",
  CONTENT_CAPTURE: "/content/capture",
  CONTENT_REVIEW: "/content/review",
  CONTENT_LIBRARY: "/content/library",
  CONTENT_STORAGE: "/content/storage",
  KNOWLEDGE_PLATFORM: "/knowledge",
  KNOWLEDGE_CORPUS: "/knowledge/corpus",
  KNOWLEDGE_PRE_RAG_REVIEW: "/knowledge/review",
  KNOWLEDGE_PRE_RAG_REVIEW_DETAIL: "/knowledge/review/:rowId",
  KNOWLEDGE_INGEST: "/knowledge/ingest",
  KNOWLEDGE_CONTENT: "/knowledge/content",
  KNOWLEDGE_CONTENT_CAPTURE: "/knowledge/content/capture",
  KNOWLEDGE_CONTENT_REVIEW: "/knowledge/content/review",
  KNOWLEDGE_CONTENT_LIBRARY: "/knowledge/content/library",
  KNOWLEDGE_CONTENT_LIBRARY_ITEM: "/knowledge/content/library/:itemId",
  KNOWLEDGE_CONTENT_STORAGE: "/knowledge/content/storage",
  KNOWLEDGE_OPS: "/knowledge/ops",
  KNOWLEDGE_EMBEDDINGS: "/knowledge/embeddings",
  KNOWLEDGE_SEARCH_LAB: "/knowledge/search-lab",
  KNOWLEDGE_EVALUATION: "/knowledge/evaluation",
  RAG_DOCUMENTS: "/rag/documents",
  RAG_INGEST: "/rag/ingest",
  RAG_OPERATIONS: "/rag/operations",
  RAG_EMBEDDINGS: "/rag/embeddings",
  RAG_SEARCH: "/rag/search",
} as const;

export type KnowledgeRouteKey = keyof typeof KNOWLEDGE_ROUTES;
